import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { Title, Meta } from '@angular/platform-browser'; 
import {CONTACT_TITLE,CONTACT_KEYWORDS,CONTACT_CONTENT,CONTACT_DESC,CONTACT_DESC_CONTENT} from  'src/app/seoconstants'; 

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit {
  contactForm:FormGroup;
  firstName:string;
  lastName:string;
  email:string;
  phNo:string;
  message:string;
  isSubmitted:string;
  parentName:string;

  title:string;
  keywords:string;
  keywordcontent:string;
  desc:string;
  desccontent:string;
  

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private titleService: Title, private metaService: Meta) {

      this.contactForm = this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', Validators.required],
        phNo:['',Validators.required],
        companyName:[''],
        message:['']
      });


     }

  ngOnInit() {

    this.title = CONTACT_TITLE;
    this.keywords = CONTACT_KEYWORDS;
    this.keywordcontent = CONTACT_CONTENT;
    this.desc = CONTACT_DESC;
    this.desccontent = CONTACT_DESC_CONTENT;

    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {name: this.keywords, content: this.keywordcontent},
      {name: this.desc, content: this.desccontent},
      {name: 'robots', content: 'index, follow'}
    ]);




  }

  saveMessage(){
  
    if(this.firstName==undefined){
      alert("Plesae Enter Your Name");
      return;
    }
    else if(this.email==undefined){
      alert("Plesae Enter Email ");
      return;
    }
    else if(this.phNo==undefined){
      alert("Plesae Enter Phone Number ");
      return;
    }

    let contactData = {
      "token":localStorage.getItem("token_data"),
      "userID":localStorage.getItem("userID"),"firstName":this.firstName,"lastName":this.lastName,
      "userEmail":this.email,
      "comment":this.message
    }

    this.apiService.saveContact(contactData).subscribe((res: any) => {
      console.log(res);
      alert("Contact Details saved and message sent successfully");
    })

  }

}
